import axios from 'axios';

const url = {
    tenantGroups: ''
};

export const initTenantManagementService = (config: Record<string, any>) => {
    url.tenantGroups = config.rulesUrl;
};
export const getTenantGroup = async (tenantGroupId: string) => {
    const res = await axios.get<TenantGroup>(`${url.tenantGroups}/tenantGroups/${tenantGroupId}`);
    return res.data;
};

export const getTenantGroups = async () => {
    const { data } = await axios.get<{ tenantGroups: TenantGroups }>(`${url.tenantGroups}/tenantGroups`);
    return data.tenantGroups;
};

export const postTenantGroup = async (values: TenantGroup) => {
    const { data } = await axios.post<TenantGroup>(`${url.tenantGroups}/tenantGroups`, values);
    return data;
};

export const deleteTenantGroup = (values: TenantGroup) => {
    return axios.delete<TenantGroup>(`${url.tenantGroups}/tenantGroups/${values.id}`);
};

export const getTenantGroupOverrides = async (
    templateRepositoryId: number,
    inherit: boolean,
    version?: number,
    tenantGroupId?: string
) => {
    const reqParams: any = {
        level: 'TENANT_GROUP',
        templateRepositoryId,
        inherit
    };
    if (tenantGroupId) {
        reqParams.tenantGroupId = tenantGroupId;
    }
    if (version) {
        reqParams.version = version;
    }

    const res = await axios.get<GlobalRulesData>(`${url.tenantGroups}/ruleRevisions/latest`, {
        params: reqParams
    });

    return res.data;
};

export const patchTenantGroupOverrides = (data: RecursivePartial<GlobalRulesData>) => {
    return axios.patch(`${url.tenantGroups}/rulerevisions`, {
        level: 'TENANT_GROUP',
        ...data
    });
};

export const deleteTenantGroupOverrides = (
    templateRepositoryId: number,
    tenantGroupId: string,
    data: { ruleIds: string[] }
) => {
    return axios.delete(`${url.tenantGroups}/rulerevisions`, {
        data: {
            templateRepositoryId,
            level: 'TENANT_GROUP',
            tenantGroupId,
            ...data
        }
    });
};

export const patchTenantGroup = (tenantGroupId: string, data: PatchTenantGroupPayload) => {
    return axios.patch(`${url.tenantGroups}/tenantGroups/${tenantGroupId}`, {
        level: 'TENANT_GROUP',
        ...data
    });
};

export const getTenantGroupInformation = async () => {
    const res = await axios.get<TenantGroupTenantEntry>(`${url.tenantGroups}/tenantGroups/tenantGroupInformation`);
    return res.data;
};
